(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.facebookAdBoostedPostFilters = definition();

    }

    function definition() {

        return {
            INCLUDE_ALL: {
                id: 'include_all',
                name: 'Include All'
            },
            EXCLUDE_BOOSTED: {
                id: 'exclude_boosted',
                name: 'Exclude Boosted'
            },
            ONLY_BOOSTED: {
                id: 'only_boosted',
                name: 'Only Boosted'
            },
            ONLY_FACEBOOK_BOOSTED: {
                id: 'only_facebook_boosted',
                name: 'Only Facebook Boosted'
            },
            ONLY_INSTAGRAM_BOOSTED: {
                id: 'only_instagram_boosted',
                name: 'Only Instagram Boosted'
            }
        };
    }
})();
